<template>
  <v-card class="elevation-0">
    <v-card-title>
      <v-container grid-list-md fluid class="pa-0">
        <v-layout align-center justify-end row fill-height>
          <v-flex class="text-xs-right" xs10>
            <v-text-field
              v-model="search"
              append-icon="search"
              class="ma-0 pa-0"
              label="Поиск"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex class="text-xs-right" xs2>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  small
                  color="success"
                  v-on="on"
                  @click="openSettings"
                >
                  <v-icon>settings</v-icon>
                </v-btn>
              </template>
              <span>Settings</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-title>
    <v-divider/>
    <v-data-table
      v-model="localSelected"
      :headers="localHeadersNormalized"
      :items="items"
      :search="search"
      :loading="loading"
      :pagination.sync="pagination"
      class="elevation-0"
    >
      <template v-slot:progress>
        <v-progress-linear
          color="success"
          height="3"
          indeterminate
        />
      </template>

      <template v-slot:items="props">
        <tr>
          <td
            v-for="{ value: field } in localHeaders"
            :key="field"
            class="no-wrap"
            :class="{'justify-center layout px-0': field === 'id'}"
          >
            <template v-if="field === 'name'">
              <router-link
                @click.prevent.stop
                :to="linkTo(props.item)"
              >
                {{ props.item[field] }}
              </router-link>
            </template>

            <template v-else-if="typeof props.item[field] === 'object'">
              <template v-if="Array.isArray(props.item[field])">
                <ul>
                  <li v-for="(value, index) in props.item[field]" :key="index">
                    <template v-if="typeof value === 'object'">
                      {{ value.name || value.title }}
                    </template>
                    <template v-else>
                      {{ value }}
                    </template>
                  </li>
                </ul>
              </template>
              <template v-else>
                <template v-if="field.includes('date')">
                  {{ props.item[field].from.value }} - {{ props.item[field].to.value }}
                </template>
                <template v-else>
                  {{ props.item[field].name || props.item[field].title || props.item[field].username }}
                </template>
              </template>
            </template>

            <template v-else>
              <template v-if="field === 'date_created'">
                {{ new Date(props.item[field]).toLocaleDateString().split('.').reverse().join('-') }}
              </template>
              <template v-else-if="field === 'status'">
                {{ props.item[field].replace(/\_/g, ' ') }}
              </template>
              <template v-else-if="field === 'id'">
                {{ props.item[field] }}
              </template>
              <template v-else>
                {{ props.item[field] }}
              </template>
            </template>
          </td>
        </tr>
      </template>

      <template v-slot:actions-append>
        <v-btn v-if="selected.length" color="error" @click="removeSelected">Delete selected</v-btn>
      </template>

      <template
        v-slot:no-results
        align="center"
        class="error--text"
      >
        Your search for "{{ search }}" found no results.
      </template>
    </v-data-table>

    <data-table-settings-popup
      :headers.sync="localHeaders"
      :dialog.sync="settingsPopupStatus"
    />
  </v-card>
</template>

<script>
export default {
  name: 'dataTable',
  props: {
    model: {},
    headers: Array,
    selected: Array,
  },
  data() {
    return {
      search: '',
      localHeaders: [...this.headers],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'id',
        totalItems: 0,
      },
      queryParams: {
        limit: 20,
        offset: 0,
      },
      settingsPopupStatus: false,
    };
  },
  watch: {
    'pagination.page': async function(page) {
      if (this.pagination.rowsPerPage < 0) return;
      const totalPages = Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
      if (page < totalPages) return;
      this.queryParams.limit = Math.round(this.pagination.rowsPerPage * 2);
      this.queryParams.offset = this.pagination.totalItems;
      await this.fetch();
    },
    'items': function(newItems) {
      this.pagination.totalItems = newItems.length;
    },
  },
  async mounted() {
    await this.fetch();
  },
  methods: {
    linkTo(item) {
      return {
        name: this.allRoutes[item.type].children[`${ item.type }Detail`].name,
        params: {
          id: item.id,
          from: this.$route.name,
        },
      };
    },
    openSettings() {
      this.settingsPopupStatus = true;
    },
    async fetch() {
      if (!this.model) return;
      await this.model.$fetch({
        params: {
          query: this.query,
        },
      });
    },
    edit(id) {
      this.$emit('edit', id);
    },
    remove(id) {
      this.$emit('delete', id);
    },
    showDetail(id) {
      this.$emit('detail', id);
    },
    removeSelected() {
      this.$emit('deleteSelected');
    },
    normalizeItems(items) {
      return items.map(obj => {
        const item = Object
          .entries(obj)
          .filter(arr => {
            const [key] = arr;
            return !key.includes('$');
          }).map(arr => {
            const [key, value] = arr;
            switch (key) {
              case 'initiator':
                arr[1] = value.username;
                break;
              case 'brand':
              case 'plant':
              case 'product':
              case 'project':
              case 'team':
              case 'technology':
                arr[1] = value ? value.name : '';
                break;
              case 'planning_date_rng':
              case 'scheduled_date_rng':
                arr[1] = (value.from.value === value.to.value)
                  ? `${ value.from.value }`
                  : `${ value.from.value } - ${ value.to.value }`;
                break;
              case 'processes':
                arr[1] = arr[1].map(i => i.name);
                break;
            }
            return arr;
          });
        return Object.fromEntries(item);
      });
    },
  },
  computed: {
    items() {
      const allItems = this.model.query().with('processes').get();
      return this.normalizeItems(allItems);
    },
    localHeadersNormalized() {
      return this.localHeaders.filter(item => item.active);
    },
    localSelected: {
      get: function() {
        return this.selected;
      },
      set: function(arr) {
        this.$emit('update:selected', arr);
      },
    },
    loading() {
      if (!this.model) return false;
      const loading = this.model.namespace('loading');
      return this.$store.getters[loading];
    },
    query() {
      const query = new URLSearchParams();
      Object.keys(this.queryParams).forEach(k => query.append(k, this.queryParams[k]));
      return query;
    },
  },
  components: {
    dataTableSettingsPopup: () => import('@/components/data/dataTableSettingsPopup'),
  },
};
</script>
